// extracted by mini-css-extract-plugin
export default {"Container":"GlobalLoader_Container__cQ8FR","Loader":"GlobalLoader_Loader__HcNIh"};